import features from "@/features.json";
import { getCookie } from "@/mixins/cookies";

function analytics(eventName, parameters) {
  const buildNumber = parseInt(getCookie("appbuild"));
  if (buildNumber >= features.analytics) {
    Object.keys(parameters).forEach(key => {
      const val = parameters[key];
      if (typeof val === "string" && val.length > 100) {
        parameters[key] = val.substring(0, 100);
      }
    });
    //eslint-disable-next-line
    NativeJS.analytics(eventName, JSON.stringify(parameters));
  }
}

export { analytics };
